import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityType } from '@/core/graphql/generated/types';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';
import { DataChangeRequest } from '@/features/DataChangeRequest/DcrModal/DataChangeRequest';
import { useBreakpoint } from '@/utils/useBreakpoint';

import { hcpDCRControlStyles as sx } from './DcrControl.styles';

type Props = {
	loading: boolean;
	entityType: EntityType;
};

export const DcrControl = ({ loading, entityType }: Props) => {
	const { t } = useTranslation();
	const isCollapsed = useBreakpoint('md', 'down');
	const [isDcrOpen, setIsDcrOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);

	const handleDcrOpen = () => {
		setIsLoading(true);
		setIsDcrOpen(true);
	};

	const handleDcrClose = () => {
		setIsLoading(false);
		setIsDcrOpen(false);
	};

	if (!dcrEnabled) {
		return null;
	}

	return (
		<>
			{!isCollapsed ? (
				<Button
					variant='outlined'
					disabled={loading}
					sx={sx.dataChangeRequestButton}
					aria-label={t('REQUEST CHANGE')}
					onClick={handleDcrOpen}
					startIcon={<EditIcon />}
					loading={isLoading}
					loadingPosition='start'
				>
					{t('REQUEST CHANGE')}
				</Button>
			) : (
				<IconButton
					disabled={loading}
					sx={sx.dataChangeRequestButton}
					aria-label={t('REQUEST CHANGE')}
					onClick={handleDcrOpen}
					color='primary'
					loading={isLoading}
				>
					<EditIcon fontSize='inherit' />
				</IconButton>
			)}

			<DataChangeRequest
				entityType={entityType}
				open={isDcrOpen}
				onClose={handleDcrClose}
				onLoaded={() => setIsLoading(false)}
			/>
		</>
	);
};
